import Sidebar from "../../../component/business/defaultLayout/Sidebar";
import Header from "../../../component/business/defaultLayout/Header";
import { Link } from "react-router-dom";
import Svg from "../../../assets/Svg";
import Png from "../../../assets/Png";
import Video from "../../../assets/Video";
import UgoPrimaryButton from "../../../component/common/UgoPrimaryButton";
import UgoFailedLable from "../../../component/common/UgoFailedLable";
import UgoPendingLable from "../../../component/common/UgoPendingLable";
import UgoPaidLable from "../../../component/common/UgoPaidLable";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { DataService, imageURL } from "../../../config/DataService";
import { Api } from "../../../config/Api";
import { toast } from "react-toastify";
import { Form, Formik } from "formik";
import UgoLoader from "../../../component/common/UgoLoader";
import { useLocation } from "react-router-dom";
import { UgoButtonLoader } from "../../../component/common/UgoLoader";
import { UgoSkeletonLoader } from "../../../component/common/UgoLoader";
import {
  ChangePasswordSchema,
  BusinessForgotPasswordSchema,
  BusinessSendOtpSchema,
  BusinessResetPasswordSchema,
  BusinessSignUpSchema,
  GetInContactSchema,
  BusinessLoginSchema,
  ProfileDetailSchema,
  CreateAdvertSchema,
  BusinessContactUs,
} from "../../../validation/validation";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import UserHeader from "../../../component/user/defaultLayout/Header";
import UserFooter from "../../../component/user/defaultLayout/Footer";

export default {
  UgoLoader,
  UgoSkeletonLoader,
  CKEditor,
  UgoButtonLoader,
  ClassicEditor,
  ChangePasswordSchema,
  CreateAdvertSchema,
  BusinessContactUs,
  ProfileDetailSchema,
  BusinessLoginSchema,
  BusinessSignUpSchema,
  GetInContactSchema,
  BusinessResetPasswordSchema,
  BusinessSendOtpSchema,
  BusinessForgotPasswordSchema,
  Api,
  imageURL,
  useLocation,
  DataService,
  toast,
  Formik,
  Form,
  Sidebar,
  useDispatch,
  Header,
  Link,
  Svg,
  Video,
  Png,
  UgoPrimaryButton,
  UgoFailedLable,
  UgoPendingLable,
  UgoPaidLable,
  useNavigate,
  UserHeader,
  UserFooter,
};
